import './_init';
var initedSound = false;
var questionInited = false;
var modalBlock = true;

var modalIntFlg = true;//モーダルを出すかどうか。

class Main {
  constructor(){
    this.$navA = $('#header .navigation nav a');

    this.setCurrent();
    this.initialize();

    // this.spHeaderTl = new TimelineMax({
    //   // paused : true
    // }).from('#spHeader',5,{y:util.win.h})

    $.pjax({
      area: '#container',
      load: {
        //head内で同期させない要素を指定。使用できるのはbase,meta,linkの3つのみ
        // head: 'base, meta, link',
        //遷移先のcssを読み込むかどうか
        // css: true,
        //遷移先のjavascriptを読み込むかどうか。※trueにした場合cssと違いどんどん蓄積されてしまう
        // script: true
      },
      link: 'a:not(.nopj)', // pjax対象のリンク
      wait: (e)=>{
        // console.log($(e.curentTarget));
        this.setNext($(e.currentTarget).attr('href'));
        if(app.device == 'pc'){
          if(this.next != 'top' && this.current == 'top'){
            return 2000;
          } else {
            return 500;
          }
        } else {
          return 500;
        }
      },
      callbacks: {
        ajax: {
          beforeSend: (e)=>{
            // console.log(e);
            this.endTransition();
            this.xHeight = $('#container').outerHeight();
            TweenMax.set('#containerHeightControll',{height: this.xHeight });
          }
        }
      },
      callback: ()=> { // 遷移完了後の処理

        this.isInternal = true;
        app.isInternal = true;

        this.setCurrent();
        this.startTransition();
        this.initialize();

        setTimeout(()=>{
          TweenMax.to('#containerHeightControll',0.5,{height: $('#container').outerHeight(),ease:Power3.easeInOut,
            onComplete: ()=>{
              TweenMax.set('#containerHeightControll',{height:'auto'});
            }
          });
        },300);
        ga('set', 'location', window.location.href);
        ga('send', 'pageview');
      }
    });

    this.menu = new Menu();

    util.win.resizeFunctions.heightControll = ()=>{
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(()=>{
        this.modal_heightControll();
        TweenMax.to('#containerHeightControll',0.5,{ height: $('#container').outerHeight() });
      },100);
    };


    this.scrollTl = new TimelineMax({
      paused: true
    })
    .to({},0.01,{})
    .set('#header .inner',{ overflow : 'hidden' })
    .to('#header .navigation h1 span',0.5,{ autoAlpha: 1, ease: Power0.easeIn },0)
    .to('#header .navigation h1, #header .navigation nav',0.5,{ y: -320, ease: Power0.easeNone },0);

    const minH = 840-8;
    var $navigation = $('#header .navigation');
    var contentH;
    util.win.scrollFunctions.scroller = ()=>{
      let prog = util.win.scrTop / 320;
      prog = Math.min(prog,1);
      prog = Math.max(prog,0);
      if(this.current != 'top'){
        this.scrollTl.progress(prog);
      } else {
        this.scrollTl.progress(0);
      }
      if( util.win.h < minH ){
        contentH = $('#wrapper').outerHeight();
        var upperArea = contentH - minH;
        if(upperArea < util.win.scrTop){
          var n = upperArea - util.win.scrTop;
          TweenMax.set($navigation,{ y: n });
        } else {
          TweenMax.set($navigation,{ y: 0 });
        }
      }
      if(this.current == 'top'){
        if(util.win.scrTop > util.win.h + 300){
          TweenMax.set('#mainVisual',{autoAlpha:0});
        } else {
          TweenMax.set('#mainVisual',{autoAlpha:1});
        }
      }

      //soundBtnの場所を変更（Y座標）
      var scrollPos = util.win.scrTop+util.win.h;
      var targetTop = $('.navigation .btn3').offset().top + $('.navigation .btn3').height() + 15;

      if(scrollPos >= $('#wrapper').outerHeight() -515)$("#soundBtn").addClass("bottom").css({opacity:1});
      else if($("#soundBtn").offset().top < targetTop){
        $("#soundBtn").css({opacity:0});

      }else{
        $("#soundBtn").removeClass("bottom").css({opacity:1});
      }

    };
    // setTimeout(()=>{
    //

    app.modals = new Modals();
    // },1000);


  }


  modal_heightControll(){
    if($(window).height()<830)$('#modal_op .modal_inner').addClass('narrow-height');
    else $('#modal_op .modal_inner').removeClass('narrow-height');
    if($(window).width()<330){
      $('#modal_op .modal_inner').addClass('narrow-height_se');
    }
  }

  initialize (){

    if(app.scene){
      delete app.scene;
    }
    switch (this.current){
      case "top":
        app.scene = new Top();
        modalBlock = false;
        this.modal_heightControll();
        break;
      case "explanation":
        app.scene = new Explanation();
        break;
      case "tour":
          app.scene = new tour();
          break;
      case "inquiry":
        app.scene = new Inquiry();
        break;
      default:
       app.scene = new Scenes();
    }

    if(this.isInternal){
      app.scene.start();
    }
    TweenMax.set('body',{position: 'relative'});
    if(this.current != 'top' && app.device == 'pc'){
      TweenMax.set('#header .navigation',{display: 'block'});
    }
    this.xCurrent = this.current;


    if(this.current != 'top')modalIntFlg = false;

    if(!initedSound && app.device == 'pc' && !modalIntFlg){
      var sound = new Howl({
        src: ['/assets/sound/bgm.mp3','/assets/sound/bgm.ogg'],
        autoplay: true,
        loop: true,
        volume: 0.2
      }).play();
      initedSound = true;
    }
    if(this.current != 'top'){
      $('#soundBtn').addClass("left");
    }
    $('#soundBtn').on({
      click: ()=>{
        if(!initedSound){
          var sound = new Howl({
            src: ['/assets/sound/bgm.mp3','/assets/sound/bgm.ogg'],
            autoplay: true,
            loop: true,
            volume: 0.2
          }).play();
          initedSound = true;
        }
        if($('#soundBtn').hasClass('off')){
          $('#soundBtn').removeClass('off');
          $('#soundBtn span').text('入');
          Howler.volume(1);
          //document.cookie = 'sound=on; max-age=60*60*24*30;';
        } else {
          $('#soundBtn').addClass('off');
          $('#soundBtn span').text('切');
          Howler.volume(0);
          //document.cookie = 'sound=off; max-age=60*60*24*30;';
        }
      }
    });


    //soundBtnの場所を変更（Y座標）
    var scrollPos = util.win.scrTop+util.win.h;
    var targetTop = $('.navigation .btn3').offset().top + $('.navigation .btn3').height() + 15;

    if(scrollPos >= $('#wrapper').outerHeight() -400)$("#soundBtn").addClass("bottom").css({opacity:1});
    else if($("#soundBtn").offset().top < targetTop){
      $("#soundBtn").css({opacity:0});

    }else{
      $("#soundBtn").removeClass("bottom").css({opacity:1});
      //console.log("mannnaka???");
    }
  }
  setCurrent (){
    this.current = $('#container').attr('class');
    TweenMax.set(this.$navA,{className:'-=cur'});
    this.$navA.each((i,el)=>{
      const href = $(el).attr('href');
      // console.log(location.pathname,href);
      if(location.pathname == href){
        TweenMax.set(el,{className:'+=cur'});
      }
    });
  }
  setNext(href){
    if( href == '/'){
      this.next = 'top';
    } else if(href == '/?sns'){
      this.next = 'sns';
    } else {
      this.next = 'lower';
    }
  }
  endTransition(){
    if(app.device == 'pc'){
      //pcの時
      if(this.current == 'top' && this.next == 'lower'){
        //トップから下層ページへ
        // $(document).off();
        // delete util.win.scrollFunctions.top;
        $('#sideTrigger').removeClass('open');
        $('#sideMenu').removeClass('open');
        TweenMax.to('#sideTrigger',0.2,{right:-30});
        var $cn = $('#top .navigation');
        var $hn = $('#header .navigation');
        var cnTop = $cn.offset().top - util.win.scrTop - 44;
        var cnLeft = $cn.offset().left - 20;
        // TweenMax.set($hn,{x:cnLeft,y:cnTop,display: 'block'});
        this.navTl = new TimelineMax({});
        this.navTl.to(window,0.5,{scrollTo:{y:util.win.h},ease:Power3.easeInOut});
        this.navTl.set($cn,{autoAlpha:0});
        this.navTl.set($('#contents .btn'),{autoAlpha:0});
        this.navTl.set($hn,{x:cnLeft,display: 'block'});

        this.navTl.add(()=>{
          for(var i = 0; i < 5; i++){
            var $btn = $('#header .btn'+(i+1));
            TweenMax.set($btn,{ y: 0 });
            // console.log($('#btn'+(i+1)).offset().top,$btn.offset().top);
            TweenMax.fromTo($btn,0.5,{y:$('#btn'+(i+1)).offset().top - $btn.offset().top},{delay:0.5,y:0, ease:Power3.easeInOut})
          }
        })
        this.navTl.to('#contents section,#mainVisual',0.5,{autoAlpha:0});
        // .to($hn,0.5,{y:0, ease:Power3.easeInOut},0)
        this.navTl.to($hn,0.5,{x:0, ease:Power3.easeInOut},"+=0.5");
        delete this.navTl;

      } else {
        TweenMax.to('html,body',0.5,{scrollTop:0,ease:Power3.easeInOut});
        TweenMax.to('#container',0.5,{autoAlpha: 0, ease: Power0.easeNone });
      }
    } else {
      //sp
      if(this.current == 'top' && this.next != 'top'){
        //トップから下層ページへ
        // $(document).off();
        // delete util.win.scrollFunctions.top;
        this.navTl = new TimelineMax({});
        this.navTl.to(window,0.5,{scrollTo:{y:$('#spHeaderControll').outerHeight()},ease:Power3.easeInOut });
        this.navTl.set('#spHeaderControll',{ display: 'none' });
        this.navTl.add(()=>{
          window.scrollTop = 0;
        });
        TweenMax.to('#container',0.5,{autoAlpha: 0, ease: Power0.easeNone });
      } else {
        TweenMax.to('#container',0.5,{autoAlpha: 0, ease: Power0.easeNone });
        TweenMax.to(window,0.5,{scrollTo:{y:0},ease:Power3.easeInOut });

      }
    }
    app.scene.end();
  }
  startTransition(){
    if(app.device == 'pc') {
      if(this.current == 'top'){
        // console.log(util.win.h-44);
        // TweenMax.set(this.$navA,{className:'-=cur'});
        // console.log("top");

        Waypoint.refreshAll();
        TweenMax.set('#mainVisualHightControll',{display: 'none'});
        var $cn = $('#top .navigation');
        var $hn = $('#header .navigation');
        var cnTop = $cn.offset().top - util.win.scrTop - 44;
        var cnLeft = $cn.offset().left - 20;
        this.navTl = new TimelineMax({});
        this.navTl.to($hn,0.5,{x:cnLeft,ease:Power3.easeInOut});
        this.navTl.add(()=>{
          for(var i = 0; i < 5; i++){
            var $btn = $('#header .btn'+(i+1));
            TweenMax.fromTo($btn,0.5,{y:0},{y:$('#btn'+(i+1)).offset().top - $btn.offset().top, ease:Power3.easeInOut})
          }
        });
        this.navTl.from('#contents section',0.5,{delay:0.5,autoAlpha:0,ease:Power0.easeNone });
        this.navTl.set($hn,{display:'none'});
        delete this.navTl;

        if(!questionInited){
          $('#questions').append('<script type="text/javascript">(function(d, t) {var a = d.createElement(t), s = d.getElementsByTagName(t)[0];a.async = a.src = "//cdn.speaklyn.com/6a57f46c3f4b49883c4270fc2b92e364.js";s.parentNode.insertBefore(a, s);}(document, "script"));</script>');

          questionInited = true;
        }

        setTimeout(()=>{
          // app.scene.isScrollable = true;

          $("#soundBtn").stop().fadeOut(300).removeClass("left").fadeIn(500);

          $('.sl-widget-box__button').attr('style', 'bottom:0px !important;background-color: #96aa00 !important;color: #ffffff !important;font-size: 12px !important;font-family: font-family:"丸丸ゴシックALr StdN R", "Maru Maru Gothic ALr StdN R" !important;');

          TweenMax.set('#mainVisualHightControll',{display: 'block'});
          Waypoint.refreshAll();
          window.scrollTo(0,util.win.h);

          // TweenMax.to('html,body',1,{scrollTop: 0});
          TweenMax.set('#containerHeightControll',{height: this.xHeight + $('#mainVisualHightControll').outerHeight(),
            onComplete: ()=>{
              TweenMax.set('#containerHeightControll',{height:'auto'});
              var top_para = location.search.substring(1);
              if(top_para){
                history.replaceState("","","/");
                $(window).scrollTop(window.InnerHeight);
                setTimeout(function(){
                  var sns_pos = $("#sns").offset().top;
                  console.log(sns_pos);
                  TweenMax.to('html,body',0.8,{
                    scrollTop:sns_pos ,ease:Power3.easeInOut,
                  });
                },1500);
              }
            }
          });

        },300);

      } else {

        $('.sl-widget-box__button').attr('style', 'bottom:-50px !important;background-color: #96aa00 !important;color: #ffffff !important;font-size: 12px !important;font-family: font-family:"丸丸ゴシックALr StdN R", "Maru Maru Gothic ALr StdN R" !important;');

        TweenMax.from('#container',0.5,{autoAlpha: 0, ease: Power0.easeNone });


        var targetTop = $('.navigation .btn3').offset().top + $('.navigation .btn3').height() + 15;
        if($("#soundBtn").offset().top < targetTop){
          $("#soundBtn").css({opacity:0});
          if(!$("#soundBtn").hasClass("left"))$("#soundBtn").addClass("left");
        }else{
          if(!$("#soundBtn").hasClass("left"))$("#soundBtn").stop().fadeOut(300).addClass("left").fadeIn(500);
        }

      }
    } else {
      //sp
      if(this.current == 'top'){
        TweenMax.fromTo('#container',0.5,{autoAlpha:0},{autoAlpha: 1, ease: Power0.easeNone });
        TweenMax.set('#mainVisual',{autoAlpha:0});
        setTimeout(()=>{
          TweenMax.set('#spHeaderControll',{display: 'block'});
          var spHeaderH = $('#spHeaderControll').outerHeight();
          // var spHeaderH = util.win.h;
          window.scrollTo(0,spHeaderH);
          TweenMax.set('#containerHeightControll',{height: this.xHeight + spHeaderH });
          TweenMax.set('#mainVisual',{autoAlpha:1,delay:0.1});

          var top_hash = location.hash;
          var sns_pos = $("#sns").offset().top;
          if(top_hash){
            history.replaceState("","","/");
            setTimeout(()=>{
              TweenMax.to('html,body',0.8,{
                scrollTop:sns_pos ,ease:Power3.easeInOut,
              });
            },1000);
          }
        },300);

      } else {
        TweenMax.from('#container',0.5,{autoAlpha: 0, ease: Power0.easeNone });
      }

    }

  }
}

class Modals {
  constructor(){
    TweenMax.set('#modals,#modalsCover',{display: 'block', autoAlpha:0});
    this.$content = $('#modals .content');
    this.$inner = $('#modals .inner');
    this.tl = new TimelineMax({
      paused: true
    })
    .to('#modals',0.5,{autoAlpha:1})
    .set('body',{overflow: 'hidden'})
    .from('#modals .modal',0.3,{ scale:0.9,delay : 0.5 , autoAlpha:0 });

    if(device.mobile()){
      $(document).on('touchstart',(e)=>{
        this.x = e.originalEvent.touches[0].clientX;
        this.y = e.originalEvent.touches[0].clientY;
        this.startX = this.x;
        this.startY = this.y;
      });
      $(document).on('touchmove',(e)=>{
        this.x = e.originalEvent.changedTouches[0].clientX;
        this.y = e.originalEvent.changedTouches[0].clientY;
        // console.log(this.x,this.y);
      });

      $(document).on('touchend','[data-modal="1"]',(e)=>{
        if( Math.abs(this.startX-this.x) < 10 && Math.abs(this.startY-this.y) < 10 ){
          this.openEvent(e);
        }
      });
      $(document).on('click','[data-modal="1"]',(e)=>{
        this.openEvent(e);
      });
    } else {
      $(document).on('click','[data-modal="1"]',(e)=>{
        this.openEvent(e);
      });
    }

    var modal_check = location.hash;

    if(modal_check){
      $('a[data-set="' + modal_check + '"]').click();
      $('li[data-set="' + modal_check + '"]').click();
    }

    $('#modals .closeModal,#modals #overlay').on({
      click : ()=>{
        history.replaceState("",""," ");
        this.close();
      }
    });

    $(document).on('click','#modals .btn a',(e)=>{
      this.close();
    });
    // $('li.type1').trigger('click');


  }
  openEvent(e){
    this.$target = $(e.currentTarget);
    this.bg = this.$target.data('bg');
    this.bg = this.bg == 'random' ? Math.floor(Math.random()*12) + 1 : this.bg;
    this.url = this.$target.data('url');
    this.set = this.$target.data('set');
    window.history.replaceState(null, null, this.set);
    if(this.isOpen){
      this.change();
    } else {
      this.open();
    }
  }
  setData(fn){
    TweenMax.set('#overlay',{ backgroundImage: 'url(/assets/img/common/paturn_'+this.bg+'.png)'});
    // if(app.device == 'sp'){
    //   var img = new Image();
    //   img.src = '/assets/img/common/paturn_'+this.bg+'.png';
    //   img.onload = ()=>{
    //     TweenMax.set('#overlay',{ backgroundSize: img.width/2+'px auto'});
    //   }
    // } else {
    //   TweenMax.set('#overlay',{ backgroundSize: 'auto'});
    // }

    $.ajax({
      url : this.url,
      dataType: 'html'
    }).always((html)=>{
      TweenMax.to(this.$inner,0.01,{scrollTo:{y:0}});
      this.$content.html(html);
      fn();
    });

    if(this.url == "/entry/" || this.url == "/donation/")$('#modals .modal .outer').addClass("entryModalOuter");
    else $('#modals .modal .outer').removeClass("entryModalOuter");

  }
  open(){
    this.isOpen = true;
    this.setData(()=>{
      this.tl.play();
    });
  }
  close(){
    this.isOpen = false;
    this.tl.reverse();
    //console.log('close modal')
  }
  change(){
    TweenMax.to('#modalsCover',0.3,{autoAlpha:1});
    setTimeout(()=>{
      this.setData(()=>{
        this.tl.progress(1);
        TweenMax.to('#modalsCover',0.3,{autoAlpha:0});
      });
    },300);
  }
}

class Menu {
  constructor(){
    this.$menu = $('#spHeader nav ul');
    this.$overlay = $('#spHeader .overlay');
    this.$trigger = $('#menuTrigger');
    this.$link = $('#spHeader a');
    this.tl = new TimelineMax({
      paused: true
    }).fromTo(this.$menu,0.5,{ y: '-100%' }, { y:'0%', ease: Power3.easeInOut })
    .from(this.$overlay,0.5,{autoAlpha:0},0);
    $('#spHeader').on({
      touchmove: (e)=>{
        if(this.isOpen){
          e.preventDefault();
        }
      }
    });
    $('#spHeader .logo a').on({
      click: ()=>{
        if(app.main.current == 'top'){
          return false;
        }
      }
    });
    this.$link.on({
      click : ()=>{
        this.close();
      }
    });
    this.$trigger.on({
      click: ()=>{
        if(this.$trigger.hasClass('open')){
          this.close();
        } else {
          this.open();
        }
      }
    });
  }
  open (){
    this.$trigger.addClass('open');
    this.tl.play();
    this.isOpen = true;
  }
  close (){
    this.$trigger.removeClass('open');
    this.tl.reverse();
  }
}

class Scenes {
  constructor(id){
    this.id = id;
  }
  end(){
  }
  start(){

  }
}

class Top extends Scenes {
  constructor(){
    super('top');
    var bgMax = 15;
    //var bgIndex = Math.floor(Math.random()*bgMax)+1;
    // var startIndex = Math.floor(Math.random()*5)+1;
    var slide_ary = [1,2,3,4,5];
    var add_ary = [6,7,8,9,10,11,12,13,14,15];

    for (var i = 0; i < 5; i++) {
      var rand = Math.floor(Math.random() * (i + 1));
      [slide_ary[i], slide_ary[rand]] = [slide_ary[rand], slide_ary[i]];
    }

    var second_num = Math.floor(Math.random()*5)+6;
    slide_ary.push(second_num);

    for (var j = 0; j < 10; j++) {
      if(add_ary[j] !== second_num){
        slide_ary.push(add_ary[j]);
      }
    }
    // var bgIndex = 0;

    // if(startIndex == 1){
    //   bgIndex = 1;
    // }
    this.insta = new insta();

    if($(".mobile").length){
      switch(slide_ary[0]){
        case 1:
          $("#bgFront").css("background-position", "left 40% center");
          break;
        case 2:
          $("#bgFront").css("background-position", "right 31% center");
          break;
        case 3:
          $("#bgFront").css("background-position", "left 21% center");
          break;
        case 4:
          $("#bgFront").css("background-position", "right 30% center");
          break;
        case 5:
          $("#bgFront").css("background-position", "left 25% center");
          break;
        case 6:
          $("#bgFront").css("background-position", "left 45% center");
          break;
        case 7:
          $("#bgFront").css("background-position", "right 36% center");
          break;
        case 8:
          $("#bgFront").css("background-position", "left 46% center");
          break;
        case 9:
          $("#bgFront").css("background-position", "right 26% center");
          break;
        case 10:
          $("#bgFront").css("background-position", "left 34% center");
          break;
      }
    }

    TweenMax.set('#bgFront',{backgroundImage:'url("/assets/img/photo/'+slide_ary[0]+'.jpg")'});

    var bgduration = 8;
    var loop_num = 1;
    var img_num = 0;

    this.bgTl = new TimelineMax({
      repeat: -1,
      paused: true
    }).to('#bgFront',bgduration,{scale:1.05,ease:Power1.easeIn})
    .add(()=>{
      img_num = slide_ary[loop_num];

      if($(".mobile").length){
        switch(img_num){
          case 1:
            $("#bgBack").css("background-position", "left 40% center");
            break;
          case 2:
            $("#bgBack").css("background-position", "right 31% center");
            break;
          case 3:
            $("#bgBack").css("background-position", "left 21% center");
            break;
          case 4:
            $("#bgBack").css("background-position", "right 30% center");
            break;
          case 5:
            $("#bgBack").css("background-position", "left 25% center");
    				break;
          case 6:
            $("#bgBack").css("background-position", "left 45% center");
            break;
          case 7:
            $("#bgBack").css("background-position", "right 36% center");
            break;
          case 8:
            $("#bgBack").css("background-position", "left 46% center");
            break;
          case 9:
            $("#bgBack").css("background-position", "right 26% center");
            break;
          case 10:
            $("#bgBack").css("background-position", "left 34% center");
            break;
        }
      }
      TweenMax.set('#bgBack',{backgroundImage:'url("/assets/img/photo/'+img_num+'.jpg")'});
    },bgduration/2)
    .to('#bgFront',2,{autoAlpha:0,ease:Power0.easeNone},'-=2')
    .add(()=>{
      if($(".mobile").length){
        switch(img_num){
          case 1:
            $("#bgFront").css("background-position", "left 40% center");
            break;
          case 2:
            $("#bgFront").css("background-position", "right 31% center");
            break;
          case 3:
            $("#bgFront").css("background-position", "left 21% center");
            break;
          case 4:
            $("#bgFront").css("background-position", "right 30% center");
            break;
          case 5:
            $("#bgFront").css("background-position", "left 25% center");
    				break;
          case 6:
            $("#bgFront").css("background-position", "left 45% center");
            break;
          case 7:
            $("#bgFront").css("background-position", "right 36% center");
            break;
          case 8:
            $("#bgFront").css("background-position", "left 46% center");
            break;
          case 9:
            $("#bgFront").css("background-position", "right 26% center");
            break;
          case 10:
            $("#bgFront").css("background-position", "left 34% center");
            break;
        }
      }
      TweenMax.set('#bgFront',{backgroundImage:'url("/assets/img/photo/'+img_num+'.jpg")'});
      if(loop_num == 14 ){
        loop_num = 0;
        slide_ary = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15];
      } else {
        loop_num += 1;
      }
    });

    this.isScrollable = false;
    var line1_1 = new SplitText("#line1_1");
    var line1_2 = new SplitText("#line1_2");
    var line1_3 = new SplitText("#line1_3");
    var line2_1 = new SplitText("#line2_1");
    var line2_2 = new SplitText("#line2_2");
    var line2_3 = new SplitText("#line2_3");
    var line2_4 = new SplitText("#line2_4");

    this.tl = new TimelineMax({
      paused : true
    })
    .add(()=>{
      if(!app.isInternal){
        TweenMax.set('html',{position: 'fixed'});
      }
    })
    //
    // .set('html',{position: 'relative'})
    .to('#mainVisual #bgs',1,{autoAlpha:1,ease:Power0.easeNone})
    .add(()=>{
      if(!modalIntFlg){
        $('#modal_op').addClass('disabled').empty();
      }
    })
    .to('#modal_op',1,{autoAlpha:1,ease:Power0.easeNone})
    .to('#mainVisual .arrow',1,{autoAlpha:1,ease:Power0.easeNone},0)
    .add(()=>{
      if(!modalIntFlg){
        modalBlock = false;
        this.tl2.play();
      }
    });

    // .to('#line1',1,{autoAlpha:1,ease:Power0.easeNone},0)
    //

    this.tl2 = new TimelineMax({
      paused : true
    })
    .to('#mainVisual #bgs',1,{autoAlpha:1,ease:Power0.easeNone})
    .to('#modal_op',0.75,{autoAlpha:0,ease:Power0.easeNone})
    // .set('#line1',{display: 'flex'})
    // .staggerFrom(line1_1.chars,0.01,{autoAlpha:0,display: 'none'},0.1)
    // .to({},0.5,{})
    // .staggerFrom(line1_2.chars,0.01,{autoAlpha:0,display: 'none'},0.1)
    // .to({},0.5,{})
    // .staggerFrom(line1_3.chars,0.01,{autoAlpha:0,display: 'none'},0.1)
    // .to({},2,{})
    // .to('#line1',1,{autoAlpha:0,ease:Power0.easeNone})
    // .to('#line2',1,{autoAlpha:1,ease:Power0.easeNone})
    // .set('#l2_1',{display: 'flex'})
    // .staggerFrom(line2_1.chars,0.01,{autoAlpha:0,display: 'none'},0.1)
    // .to({},0.5,{})
    // .staggerFrom(line2_2.chars,0.01,{autoAlpha:0,display: 'none'},0.1)
    // .to({},1,{})
    // .set('#l2_2',{display: 'flex'})
    // .staggerFrom(line2_3.chars,0.01,{autoAlpha:0,display: 'none'},0.1)
    // .to({},0.5,{})
    // .staggerFrom(line2_4.chars,0.01,{autoAlpha:0,display: 'none'},0.1)
    // .to({},2,{})
    // .to('#line2',1,{autoAlpha:0,ease:Power0.easeNone})
    .to('#mainVisual .logo',1.5,{autoAlpha:1,ease:Power0.easeNone},0.1)
    // .to({},2,{})
    //.set('html',{position: 'relative'})
    .add('end')
    .add(()=>{
      this.bgTl.play();
      if(!this.isScrollable){
        //this.showContent();
      }
    });

    $('#modal_op .close').on({
      click: ()=>{
        closeModal();
        this.tl2.play();
      }
    });
    $('#modal_op a').on({
      click: ()=>{
        $('#modal_op').css("opacity", 0);
        isScrollable = false;
        modalBlock = false;
        this.tl2.progress(1);
      }
    });
    // $('#modal_op .bg').on({
    //   click: ()=>{
    //     closeModal();
    //     this.tl2.play();
    //   }
    // });
    function closeModal(){
      modalBlock = false;
      if(app.device == 'pc'){
        if(!initedSound){

          var sound = new Howl({
            src: ['/assets/sound/bgm.mp3','/assets/sound/bgm.ogg'],
            autoplay: true,
            loop: true,
            volume: 0.2
          }).play();
          initedSound = true;
        }
      }
    }

    $(document).on({
      mousewheel : (e)=>{
        if(!this.isScrollable && !modalBlock){
          e.preventDefault();
          var y = e.deltaY;
          if(y < 0){
            this.showContent();
          }
        }
      },
      touchstart : (e)=>{
        this.startY = e.originalEvent.touches[0].pageY;
        // console.log("start", this.startY);
      },
      touchmove: (e)=>{
        if(modalBlock)return;
        if(!this.isScrollable){
          e.preventDefault();
          // var now = this.tl.progress();
          // this.moveY = e.originalEvent.changedTouches[0].pageY;
          // var next = Math.min(now+(this.startY - this.moveY)/2000,1);
          // this.tl.progress(next,false);
          this.moveY = e.originalEvent.changedTouches[0].pageY;
          var y = this.startY - this.moveY;
          if(y > 0){
            this.showContent();
          }
          this.startY = this.moveY;
        }
      }
    });
    if(!app.isInternal){
      $('#mainVisual .bg').imagesLoaded({background: true},()=>{
        this.tl.play();
      });
    } else {
      this.isScrollable = true;
      this.isHidable = true;
    }

    $('#mainVisual .arrow').on({
      click: ()=>{
        // this.tl.tweenTo(this.tl.totalDuration(),{ ease:Power3.easeInOut }).duration(1.5);
        modalBlock = false;
        this.showContent();
      }
    });


    this.$slider = $('#contents .slider');
    //console.log(this.$slider);
    this.$aboutSlider = $('#about ul');
    if(app.device == 'pc'){
      this.setPcSlide();
      $('#about .vimeo').append('<iframe id="videoFrame" class="pc" src="https://player.vimeo.com/video/225398449?autoplay=1&loop=1&autopause=0" frameborder="0" ></iframe>');
      var player = new Vimeo.Player($('#videoFrame'));

      //var cookies = document.cookie.indexOf("sound=off",0);
      //player.on('play', function() {
      //  if(cookies != -1)$('#soundBtn').click();
      //});


    } else {
      this.setSpSlide();
      $('#about .vimeo').append('<iframe class="sp" src="https://player.vimeo.com/video/225745499?autoplay=1&loop=1&autopause=0" frameborder="0"></iframe>');
      //
    }
    app.pcFunctions.top = ()=>{
      this.$slider.each((i,el)=>{
        $(el).find('ul').eq(0).slick('unslick');
      });
      this.$aboutSlider.slick('unslick');
      this.setPcSlide();
    }
    app.spFunctions.top = ()=>{
      this.$slider.each((i,el)=>{
        this.slider[i].destroy();
      });
      this.setSpSlide();
    }
    this.$navA = $('#top .navigation nav a');
    this.$navA.on({
      click: (e)=>{
        this.setNavCur(e.currentTarget);
      }
    });
    $('#btn1 a,#btn2 a,#btn3 a,#btn5 a').on({
      click: (e)=>{
        this.setNavCur(e.currentTarget);
      }
    });

    var $sideTrigger = $('#sideTrigger');
    var $soundBtn = $('#soundBtn');
    var $sideMenu = $('#sideMenu');
    this.waypoint = $('#contents').waypoint((direction)=>{
      if(direction == 'down'){
        TweenMax.to($sideTrigger,0.3,{right:30});
      } else {
        TweenMax.to($sideTrigger,0.3,{right:-30});
        $sideMenu.removeClass('open');
        $sideTrigger.removeClass('open');
      }
    },{offset:0});
    $sideTrigger.on({
      click: ()=>{
        if($sideTrigger.hasClass('open')){
          $sideTrigger.removeClass('open');
          $sideMenu.removeClass('open');
        } else {
          $sideTrigger.addClass('open');
          $sideMenu.addClass('open');
        }
      }
    });

    $sideMenu.find('a').on({
      click: ()=>{
        $sideTrigger.removeClass('open');
        $sideMenu.removeClass('open');
      }
    });

    util.win.scrollFunctions.top = ()=>{
      if(this.isHidable){
        var h = $('#mainVisualHightControll').outerHeight();
        h = util.ua.isIosChrome ? util.win.h : h;
        if(util.win.scrTop < h - 2){
          this.hideContent();
        }
      }
    }
  }
  hideContent(){
    this.isHidable = false;
    this.tl2.progress(1);//★★★★★★まるもりへふっとぶ
    // TweenMax.killTweensOf('html,body');
    // this.tl.seek('end').pause();
    this.bgTl.play();

    TweenMax.to('html,body',0.8,{scrollTop:0 ,ease:Power3.easeInOut,
      onComplete: ()=>{
        this.isScrollable = false;
        TweenMax.set('html',{position: 'fixed'});
      }
    });
  }
  showContent(){
    this.bgTl.pause();
    this.isScrollable = true;
    $(".pager ul li:first-child").trigger('click');
    TweenMax.set('html',{position: 'relative'});
    // TweenMax.killTweensOf('htmln,body');
    var h = $('#mainVisualHightControll').outerHeight();
    h = util.ua.isIosChrome ? h + 55 : h;
    TweenMax.to('html,body',0.8,{scrollTop: h,ease:Power3.easeInOut,
    onComplete: ()=>{
      setTimeout(()=>{
        this.isHidable = true;
        this.tl2.progress(1);//★★★★★★まるもりへふっとぶ
      },100);
    }
    });


    if(!questionInited){
      $('#questions').append('<script type="text/javascript">(function(d, t) {var a = d.createElement(t), s = d.getElementsByTagName(t)[0];a.async = a.src = "//cdn.speaklyn.com/6a57f46c3f4b49883c4270fc2b92e364.js";s.parentNode.insertBefore(a, s);}(document, "script"));</script>');

      questionInited = true;
    }
  }
  setNavCur(el){
    const $this = $(el);
    const xhref = $this.attr('href');
    TweenMax.set($this,{ className: '+=cur'});
    setTimeout(()=>{
      TweenMax.set($this,{ className: '-=cur'});
    },3000);
    app.main.$navA.each((i,el)=>{
      const href = $(el).attr('href');
      // console.log(xhref , href);
      if(xhref == href){
        TweenMax.set(el,{className:'+=cur'});
      }
    });
  }
  setPcSlide (){
    this.slider = [];
    this.$slider.each((i,el)=>{
      this.slider.push(new Slider($(el),i));
    });
  }
  setSpSlide(){
    this.$slider.each((i,el)=>{
      if(i == 0){
        var padding = '14%';
      } else {
        var padding = '25%';
      }
      var $ul = $(el).find('ul');
      var $li = $(el).find('li');
      $li.each((i,li)=>{
        $ul.prepend(li);
      });

      $(el).find('ul').slick({
        centerMode : true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        centerPadding: padding,
        rtl : true,
        //         lazyLoad: 'ondemand',
        // slidesToShow: 3,
        // slidesToScroll: -1,
        // rtl: true,
        // swipeToSlide: true,
        // centerMode: false,
        // autoplay: true,
        // autoplaySpeed: 3000,
        // arrows: false
      });
    });
    this.$aboutSlider.slick({
        centerMode : true,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        centerPadding: '14%',
        rtl : true,
        //         lazyLoad: 'ondemand',
        // slidesToShow: 3,
        // slidesToScroll: -1,
        // rtl: true,
        // swipeToSlide: true,
        // centerMode: false,
        // autoplay: true,
        // autoplaySpeed: 3000,
        // arrows: false
      });
  }
  end(){
    super.end();
    // this.waypoint.destroy();
  }
  start(){
    super.start();
  }
}

class Slider {
  constructor($el,times){
    this.$el = $el;
    this.$li = $el.find('li');
    this.$ul = $el.find('ul');
    this.length = this.$li.length;
    var pagers = '';
    var widthArray = [];
    if($el.attr("id") == "snsSlider"){
      this.length = this.length;
    }
    for(var i = 0; i < this.length; i++){
      pagers += '<li></li>';
      widthArray.push(this.$li.eq(i).outerWidth());
    }
    this.$el.closest('section').find('.pager ul').html(pagers);
    this.$pager = $el.closest('section').find('.pager li');
    this.$pager.eq(0).addClass('cur');

    this.tl = new TimelineMax({
      repeat: -1,
      paused: true
    });
    var pager = (i)=>{
      this.$pager.removeClass('cur');
      var index = i == this.length ? 0 : i;
      this.$pager.eq(index).addClass('cur');
    }
    this.$li.each((i,el)=>{
      var j = i+1;
      this.tl.add(()=>{
        pager(i);
      });
      this.tl.add('card'+j);
      this.tl.add(()=>{
      });
      this.tl.set(el,{className:'+=open'});
      // if(this.$el.attr('id') == "snsSlider"){
      //   console.log(el);
      // }
      this.tl.to({},5,{});
      this.tl.add(()=>{
        if(this.isPaused){
          this.tl.pause();
        }
      });

      this.tl.to(el,0.5,{autoAlpha:0,ease:Power0.easeInOut});
      this.tl.to(this.$ul,0.8,{x:"+="+$(el).outerWidth(),ease:Power3.easeInOut});
      this.tl.set(el,{className:'-=open'});
      this.tl.set(el,{autoAlpha:1});

    });
    this.$ul.append(this.$li.clone());
    if(times > 0){
      this.$ul.append(this.$li.clone());
    }
    if(times = 1){
      this.$ul.append(this.$li.clone());
    }

    this.$allList = $el.find('li');

    this.delayTimer = setTimeout(()=>{
      this.play();
    },Math.random()*1000)

    this.$ul.on({
      mouseenter : ()=>{
        this.isPaused = true;
      },
      mouseleave : ()=>{
        this.play();
      }
    });
    // console.log(widthArray);
    this.$pager.on({
      click:(e)=>{
        var index = $(e.currentTarget).index();
        // this.tl.tweenTo('card'+(index+1)).duration(0.5);
        var x = 0;
        for(var i = 0; i < index; i++){
          x += widthArray[i];
        }
        var ulX = this.$ul.get(0)._gsTransform ? this.$ul.get(0)._gsTransform.x : 0;
        x = x - ulX;
        // console.log();
        TweenMax.to(this.$allList,0.5,{x:x,ease:Power3.easeInOut,onComplete:()=>{
          this.tl.seek('card'+(index+1)).play;
          TweenMax.set(this.$allList,{x:0});
        }});
        setTimeout(()=>{
          // this.play();
        },500);
      }
    });
  }
  play(){
    this.isPaused = false;
    this.tl.play();
  }
  destroy(){
    clearTimeout(this.delayTimer);
    this.$ul.off();
    this.tl.seek(0).pause();
    this.$ul.css('transform','');
    this.tl.remove();
    delete this.tl;
    this.$ul.html(this.$li);
  }
}

class Inquiry extends Scenes {
  constructor(){
    super('inquiry');
    const formId = 'question';
    const rules = {
      name: { required: true, maxlength: 50 },
      mail: { required: true, email: true, maxlength: 100 },
      question: { required: true, maxlength: 2000 }
    };
    this.form = new Form(formId, $('#'+formId).attr('action'), rules, this);
  }
}

class Tour extends Scenes {
  constructor(){
    super('tour');
    const formId = 'field';
    const rules = {
      name: { required: true, maxlength: 50 },
      mail: { required: true, email: true, maxlength: 100 },
      birthYear: { required: true },
      birthMonth: { required: true },
      birthDay: { required: true },
      job: { required: true }
    };
    this.form = new Form(formId, $('#'+formId).attr('action'), rules, this);
  }
}

class Explanation extends Scenes {
  constructor(){
    super('explanation');
    const formId = 'briefing';
    const rules = {
      place: { required: true },
      name: { required: true, maxlength: 50 },
      mail: { required: true, email: true, maxlength: 100 },
      birthYear: { required: true },
      birthMonth: { required: true },
      birthDay: { required: true },
      job: { required: true }
    };
    this.form = new Form(formId, $('#'+formId).attr('action'), rules, this);
  }
}

class Form {
  constructor(id, postUrl, rule, parent){
    this.rule = rule;
    this.postUrl = postUrl;
    this.parent = parent;
    // this.$modalContaier = this.parent.$modal.find('.container');;
    this.$form = $('#'+id);
    this.$input  = $('#input');
    this.$confirm = $('#confirm');
    this.$complete = $('#complete');
    this.$progress = $('#progress li');
    //標準エラーメッセージの変更
    $.extend($.validator.messages, {
      email: '正しいメールアドレスを入力してください。',
      required: 'この項目は必須となります。',
      // number: '半角数字で入力してください。',
      // minlength: '10桁～11桁の半角数字を入力してください',
      maxlength: '入力文字数の'
    });
    //バリデーションの追加
    // $.validator.addMethod("zip", function(value, element) {
    //   return this.optional(element) || /^[0-9\-]+$/.test(value);
    // }, "半角数字で入力してください。");
    // $.validator.addMethod('filesize', function(value, element, param) {
    //     // param = size (en bytes)
    //     // element = element to validate (<input>)
    //     // value = value of the element (file name)
    //     return this.optional(element) || (element.files[0].size <= param)
    // });

  　//追加ルールの定義
    // var methods = {
    //   phone: function(value, element){
    //     return this.optional(element) || /^\d{11}$|^\d{3}-\d{4}-\d{4}$/.test(value);
    //   }
    // };

    //メソッドの追加
    // $.each(methods, function(key) {
    //   $.validator.addMethod(key, this);
    // });

    //入力項目の検証ルール定義


    //入力項目ごとのエラーメッセージ定義
    var messages = {
      // occupation: {
      //   required: "選択してください。"
      // }
    };

    // form用event
    this.$form.find('#btnConfirm').on({
      click: ()=>{
        this.$form.submit();
      }
    });

    this.$form.find('.back').on({
      click: ()=>{
        // app.modals.close();
      }
    });

    this.$form.validate({
      groups: {
          birthday: "birthYear birthMonth birthDay"
      },
      rules: this.rule,
      messages: messages,
      submitHandler: (form)=> {
        this.formData = new FormData( this.$form.get(0) );
        this.confirm();
        // console.log(this.formData);
        return false;
      },
      errorPlacement: function(error, element){
        error.appendTo(element.parents('dd').find('.err'));
        // if (element.is('select')) {
        //   error.appendTo(element.parent().parent('.err'));
        // } else if (element.is(':radio')) {
        //   error.appendTo(element.parents('dd').find('.err'));
        // } else {
        //   error.appendTo(element.parents('dd').find('.err'));
        // }
      }
    });

    // confirm event
    this.$confirm.find('#btnBack').on({
      click: ()=>{
        this.form();
      }
    });
    this.$confirm.find('#btnSubmit').on({
      click: ()=>{
        this.send();
      }
    });
  }
  reset(){
    this.$form.get(0).reset();
    TweenMax.set([ this.$confirm,this.$complete ], { autoAlpha: 0, display: 'none' })
    TweenMax.set(this.$input, { autoAlpha: 1, display: 'block' })
  }
  form(){
    this.change(this.$confirm, this.$input);
    this.$progress.removeClass('cur');
    this.$progress.eq(0).addClass('cur');
  }
  confirm(){
    // for (var [key, val] of this.formData.entries()) {
    //   if ( key == 'upfile' || key == 'upfile1' || key == 'upfile2' || key == 'upfile3' ){
    //     this.$confirm.find(`.${key}`).text(val.name);
    //   } else {
    //     this.$confirm.find(`.${key}`).text(val);
    //   }
    // }

    //サファリなどが対応してないのでこちらの形に変更
    this.formDataText = _.chain(this.$form.serializeArray())
      .map( function(input) {
        return [input.name, input.value];
      })
      .object().value();

    $.each(this.formDataText, (key,val)=>{
      if(key == 'place'){
        val = val == 0 ? '東京会場' : '仙台会場';
      }
      this.$confirm.find(`.${key}`).text(val);
    });
    this.change(this.$input, this.$confirm);
    this.$progress.removeClass('cur');
    this.$progress.eq(1).addClass('cur');
  }
  send(){
    // console.log(this.postUrl,this.formData);
    $.ajax(this.postUrl, {
      type: 'post',
      dataType: 'json',
      data: this.formData,
      processData: false,
      contentType: false,
    })
    .done((json)=>{
      // console.log(json);
      if ( json.result == true ){
        this.complete();
      }
    })
    .fail(()=>{
      if ( location.href.indexOf('192.168') != -1 || location.href.indexOf('localhost') ){
        this.complete();
      } else {
        alert('送信に失敗しました');
      }
    })
  }
  complete(){
    this.change(this.$confirm, this.$complete);
    this.$progress.removeClass('cur');
    this.$progress.eq(2).addClass('cur');
  }
  change(hide,show,){
    var hideCont= hide;
    var showCont = show;
    new TimelineMax()
    .to(hideCont, 0.3, { autoAlpha: 0 })
    .set(showCont, { display: 'block' })
    .set(hideCont, { display: 'none' })
    .to(showCont, 0.3, { autoAlpha: 1 })
  }
}

class ModalController {
  constructor(
    overlay = '#overlay',
    container = '#modals .modal',
    content = '#modals .content',
    closeModal = '#modals .closeModal'
  ){
    this.$overlay = $(overlay);
    this.$container = $(container);
    this.$content = $(content);
    this.$modallink = $(modallink);
    this.isOpen = false;
    this.data = {};

    $.each($(this.$content), (i, _this)=>{
      let id = $(_this).attr('id');
      this.data[id] = new ModalContent(id, this );
    });

    this.$closeModal.on({
      click: ()=>{
        this.close();
      }
    });

    $(window).on({
      resize: ()=>{
        this.resize();
      }
    });

    //event など
    this.data.m1.beforeShowFn = ()=>{
      setTimeout(()=>{
        this.data.m1.showTransition();
      },2000);
    }
    this.open('m1');
  }
  open(id,opt){
    this.data[id].open(opt)
  }
  change(id){
    this.data[id].change();
  }
  close(){
    this.data[this.current].close();
  }
  resize(){
    if ( this.isOpen ){
      this.data[this.current].setHeight(true);
    }
  }
}

class ModalContent {
  constructor(id, modals){
    // console.log(modals);
    this.modal = modals;
    this.id = id;
    this.isOpen = false;
    this.$content = $(`#${id}`);
    this.showDuration = 0.3;
    this.openDuration = 0.3;
    this.heightDuration = 0.7;
    this.$content.find('.close').on({
      click: ()=>{
        this.close();
      }
    })
  }
  open(opt){
    this.opt = opt ? opt : null;
    if ( !this.modal.isOpen ){
      this.modal.isOpen = true;
      TweenMax.set( this.modal.$container, { scale: 1 })
      this.reset();
      this.setHeight(true);
      new TimelineMax()
        .to( this.modal.$overlay, this.openDuration, { autoAlpha: 1 }, 0 )
        .fromTo( this.modal.$container, this.openDuration, { scale: 0.5 }, { scale: 1, autoAlpha: 1 }, 0 )
        .add(()=>{ this.beforeShow() })
        .add(()=>{ this.beforeShowFn() })
    } else {
      this.change();
    }
  }
  change(){
    this.modal.isChange = true;
    const exContent = this.modal.data[this.modal.current];
    new TimelineMax()
      //消す
      .add(()=>{ exContent.setHeight(true) })
      .to( exContent.$content, this.showDuration, { autoAlpha: 0 })
      .add(()=>{ exContent.afterClose() })
      .add(()=>{ exContent.afterHideFn() })
      .add(()=>{ this.beforeShow() })
      .add(()=>{ this.beforeShowFn() })
  }
  close(){
    new TimelineMax()
    .to(this.modal.$overlay, this.openDuration, { autoAlpha: 0 }, 0 )
    .to( this.modal.$container, this.openDuration, { scale: 0.95, autoAlpha: 0 }, 0 )
    .add(()=>{ this.modal.isOpen = false })
    .add(()=>{ this.afterClose() })
    .add(()=>{ this.afterHideFn() })
  }
  setCurrent(){
    this.modal.current = this.id;
  }
  setHeight( noAnim ){
    const contentH = this.$content.outerHeight();
    const outerH = Math.min( contentH, util.win.h-100 );
    if ( noAnim ){
      TweenMax.set( this.modal.$container.find('.outer'), { height: outerH });
    } else {
      TweenMax.to( this.modal.$container.find('.outer'), this.heightDuration, { height: outerH, ease: Power3.easeInOut });
    }
    // clearTimeout(this.timer);
    // this.timer = setTimeout(()=>{
    //   console.log(contentH, outerH);
    //   if ( contentH <= outerH ){
    //     TweenMax.set( this.modal.$container.find('.outer'), { height: '' })
    //   }
    // },this.heightDuration*1000)
  }
  reset(){
    $.each(this.modal.data, (i, el) => {
      TweenMax.set( el.$content, { autoAlpha: 0, display: 'none' });
      el.isOpen = false;
    });
    TweenMax.set( this.modal.$overlay, { autoAlpha: 0, display: 'block' });
    TweenMax.set( this.modal.$container, { autoAlpha: 0 });
    TweenMax.set( this.$content, { autoAlpha: 0, display: 'block' });
  }
  beforeShow(){
    this.setCurrent();
    TweenMax.set( this.$content, { display: 'block', autoAlpha: 0 });
  }
  beforeShowFn(){
    //準備ができたらthis.showTransition();
    this.showTransition();
  }
  showTransition(){
    const delay = this.modal.isChange ? this.heightDuration : 0;
    new TimelineMax()
    .add(()=>{ this.setHeight() })
    .to( this.$content, this.showDuration, { autoAlpha: 1, delay: delay })
    .add(()=>{ this.afterShowFn() })
    this.modal.isChange = false;
  }
  afterShowFn(){
  }
  afterClose(){
    TweenMax.set( this.$content, { autoAlpha: 0, display: 'none' });
  }
  afterHideFn(){
    // 自由に適宜
  }
}

class insta {
  constructor() {
    //instagram情報表示
    const apiPath = location.protocol + '//' + location.host + '/php/api/exe.php';
    // console.log(apiPath);
    const instagram = $('#marumori-now');

    $.ajax({
      url: apiPath,
      type: "GET",
      dataType: "json",
      async: false,
    }).done(function (data) {
      //console.log(data);
      if (data == null) {
        //console.log('null');
      } else {
        var i = 1;
        var html = '';
        data.forEach(function (element) {
          // console.log(element);
          // console.log(i);
          if(app.device == 'pc'){
            if (i % 2 === 1) {
              html += '<li>';
            }
          } else {
            html += '<li>';
          }
          var type = element["data_type"];
          var set_img = element["img"];
          if(!set_img){
            set_img = "/assets/img/common/blank_marumori.jpg";
          }
          if (type === 'instagram') {
            var img = '<img src="/assets/img/common/sns_ins.svg" alt=""/>';
          } else if (type === 'rss') {
            var img = '<img src="/assets/img/common/sns_rss.svg" alt=""/>';
          } else if (type === 'facebook') {
            var img = '<img src="/assets/img/common/sns_fb.svg" alt=""/>';
          }
          html += '<div class="sns_set"><a class="photo" href="'
            + element["url"]
            + '" target="_blank"><img src="'
            + set_img
            + '" alt=""/></a><div class="icon">'
            + img
            + '</div></div>';
          if(app.device == 'pc'){
            if (i % 2 === 0) {
              html += '</li>';
            }
          } else {
            html += '</li>';
          }
          i++;
        });
        instagram.prepend(html);
      }
    }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
      //console.log(textStatus);
    });
  }
}

class blog {
  constructor(blog_id) {
    const blog_num = blog_id.substr(4);

    console.log(blog_num);

    //起業家ページのレポート情報表示
    const apiPath_bg = location.protocol + '//' + location.host + '/php/api/blog.php?blog_num=' + blog_num;

    $.ajax({
      url: apiPath_bg,
      type: "GET",
      dataType: "json",
      async: false,
    }).done(function (data) {
      //console.log(data);
      if (data == null) {
        //console.log('null');
      } else {
        var blog_html = '';
        data.forEach(function (element) {
          // console.log(i);
          var set_img = element["img"];
          if(!set_img){
            set_img = "/assets/img/common/blank_marumori.jpg";
          }
          blog_html += '<li style="background: url(';
          blog_html += "'" + set_img + "') no-repeat center/cover;" + '">';
          blog_html += '<a href="'
            + element["url"]
            + '" target="_blank"></a>'
          blog_html += '</li>';
        });

        setTimeout(function(){
          $(".activity ul").html(blog_html);
        },1000);
      }
    }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
      //console.log(textStatus);
    });
  }
}

$(()=>{
  $(document).on("click", ".blogs li", function(){
    const blog_id = $(this).attr("id");
    this.blog = new blog(blog_id);
  });
  $(".pos_sns").on('click',function(){
    if($("#sns").length){
      var sns_pos = $("#sns").offset().top;
      TweenMax.to('html,body',0.8,{
        scrollTop:sns_pos ,ease:Power3.easeInOut,
      });
      return false;
    }
  });
  if(device.tablet()){
    $('meta[name=viewport]').attr('content','width=1200,user-scalable=no')
  }
  app.isInternal = false;
  app.pcFunctions = {};
  app.spFunctions = {};
  util.win.resizeFunctions.checkDevice = ()=>{
    if (util.win.w > 760 || device.tablet() ) {
      if( !app.device || app.device == 'sp'){
        app.device = 'pc';
        for(var key in app.pcFunctions){
          app.pcFunctions[key]();
        }
      }
    } else {
      if(!app.device || app.device == 'pc'){
        app.device = 'sp';
        for(var key in app.spFunctions){
          app.spFunctions[key]();
        }
      }
    }
  };
  util.win.resizeFunctions.checkDevice();
  app.main = new Main();
  app.pcFunctions.navigation = ()=>{
    if(app.main.current == 'top'){
      TweenMax.set('#header .navigation',{display: 'none'});
    } else {
      TweenMax.set('#header .navigation',{display: 'block'});
    }
  };
  app.spFunctions.navigation = ()=>{
    if(app.main.current == 'top'){
      TweenMax.set('#spHeaderControll',{display: 'block'});
    } else {
      TweenMax.set('#spHeaderControll',{display: 'none'});
    }
  };
});



// WEBPACK FOOTER //
// ./src/assets/js/_main.es6